import { type ComponentProps } from 'react';
import styled from 'styled-components';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale, t } from '@ardoq/i18n';
import { type Locale } from '@ardoq/locale';
import { DateOnlyPicker } from './DateOnlyPicker';

const ToLabel = styled.label`
  display: flex;
  align-items: center;
`;

type DatePickerProps = Omit<
  ComponentProps<typeof DateOnlyPicker>,
  'placeholder'
>;

export type DateBetweenPickerProps = {
  startDatePicker: DatePickerProps;
  endDatePicker: DatePickerProps;
  locale: Locale;
  i18nLocale?: I18nLocale;
};

const DateBetweenPicker = ({
  startDatePicker,
  endDatePicker,
  locale,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: DateBetweenPickerProps) => (
  <>
    <div style={{ flex: 1 }}>
      <DateOnlyPicker
        {...startDatePicker}
        config={{ locale, ...startDatePicker.config }}
        i18nLocale={i18nLocale}
        placeholder={t(
          i18nLocale,
          'dateTimePicker:startDatePlaceholder',
          'Start date…'
        )}
      />
    </div>
    <ToLabel htmlFor={endDatePicker.inputId}>
      {t(i18nLocale, 'dateTimePicker:toLabel', 'to')}
    </ToLabel>
    <div style={{ flex: 1 }}>
      <DateOnlyPicker
        {...endDatePicker}
        config={{ locale, ...endDatePicker.config }}
        i18nLocale={i18nLocale}
        placeholder={t(
          i18nLocale,
          'dateTimePicker:endDatePlaceholder',
          'End date…'
        )}
      />
    </div>
  </>
);

export { DateBetweenPicker };
